import { jsx as _jsx } from "react/jsx-runtime";
import "./setup";
import { Root } from "./Root";
import { resolveClientLoader } from "./clientLoaderResolver";
import { render } from "./render";
import { handleSkewError, isChunkLoadError } from "./utils/dynamicImport";
import { findRootLayout } from "./utils/findRootLayout";
function createApp(options) {
  globalThis["__vxrnIsSPA"] = true;
  globalThis["__vxrnHeadless"] = true;
  var setupComplete = options.getSetupPromise ? options.getSetupPromise() : Promise.resolve();
  return setupComplete.then(function() {
    return findRootLayout(options.routes, options.routerRoot);
  }).then(function() {
    return resolveClientLoader({});
  }).then(function() {
    render(/* @__PURE__ */ _jsx(Root, {
      isClient: true,
      flags: options.flags,
      routes: options.routes,
      routerRoot: options.routerRoot,
      linking: options.linking,
      path: options.path || (typeof window !== "undefined" ? window.location.href : "/")
    }));
  }).catch(function(err) {
    console.error(`[one/headless] Error during initialization:`, err);
    if (isChunkLoadError(err)) {
      handleSkewError();
    }
  });
}
export {
  Root,
  createApp
};
//# sourceMappingURL=headless.js.map
